// atlas/client/src/lib/auth_store.ts — the saved session token (THE LOGIN, 2026-10-05) and the last known status.
import { TOKEN_KEY } from '../config.js';

export function getToken(): string | null { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } }
/** Refuses anything but a non-empty string: a bad 2xx once stored "undefined" as the session (final review F7). */
export function setToken(t: string): void {
  if (typeof t !== 'string' || !t) return;
  try { localStorage.setItem(TOKEN_KEY, t); } catch { /* blocked storage: the session lasts the page */ }
}
export function clearToken(): void { try { localStorage.removeItem(TOKEN_KEY); } catch { /* fine */ } }
export const authStatus: { claimed: boolean | null; codesLeft: number; username: string | null } = { claimed: null, codesLeft: 0, username: null };
